import { TrophyIcon as PhosphorTrophyIcon } from "@phosphor-icons/react/dist/ssr/Trophy";

import { createAppIcon } from "@/components/createAppIcon";

export const TrophyIcon = /* @__PURE__ */ createAppIcon(PhosphorTrophyIcon);
